import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const PriceTrendsReport = () => {
  const [filters, setFilters] = useState({});
  const [saleTrend, setSaleTrend] = useState([]);
  const [rentTrend, setRentTrend] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/reports/price-trends", { params: filters });
      setSaleTrend(res.data.sale_trend || []);
      setRentTrend(res.data.rent_trend || []);
    } catch (err) {
      console.error("Failed to load price trends", err);
      setSaleTrend([]);
      setRentTrend([]);
    } finally {
      setLoading(false);
    }
  };

  const download = async (type) => {
    try {
      const res = await axios.get(`/api/reports/price-trends/${type}`, {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `price-trends-report.${type === "csv" ? "csv" : "pdf"}`);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(`Failed to download ${type}`, err);
    }
  };

  const renderTrendTable = (rows, title) => (
    <div className="card shadow-sm mb-3">
      <div className="card-body table-responsive">
        <h6 className="fw-bold mb-3">{title}</h6>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Month</th>
              <th>Avg Price/Sqft</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  {loading ? "Loading..." : "No data"}
                </td>
              </tr>
            ) : (
              rows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.month}</td>
                  <td>{Number(row.avg_price_per_sqft || 0).toFixed(2)}</td>
                  <td>{row.count}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Price Trends (Sale & Rent)</h4>

      <ReportFilter filters={filters} setFilters={setFilters} onSearch={fetchReport} />

      <div className="card mb-3">
        <div className="card-body d-flex justify-content-end gap-2">
          <button className="btn btn-primary" onClick={fetchReport}>
            {loading ? "Loading..." : "Search"}
          </button>
          <button className="btn btn-outline-danger" onClick={() => download("pdf")}>
            PDF Download
          </button>
          <button className="btn btn-outline-secondary" onClick={() => download("csv")}>
            CSV Download
          </button>
        </div>
      </div>

      {renderTrendTable(saleTrend, "Sale Price per Sqft (by month)")}
      {renderTrendTable(rentTrend, "Rent Price per Sqft (by month)")}
    </div>
  );
};

export default PriceTrendsReport;

